import React, { useEffect, useState } from 'react';
import { Select } from '../../components/ui';
import { queryEFormReport } from '../../services/mutations';
import ReportPivotResult from './ReportPivotResult';
import {
  type EFormReportChartType,
  type EFormReportQueryResult,
  useEFormSavedReports,
} from './useData';

export const EFORM_SAVED_REPORT_WIDGET_ID = 'eform-saved-report';

export function SavedReportWidget({
  settings,
  editing,
  onSettingsChange,
}: {
  settings: Record<string, unknown>;
  editing?: boolean;
  onSettingsChange?: (settings: Record<string, unknown>) => void;
}) {
  const definitionId = Number(settings.definitionId || 0);
  const { data: reports } = useEFormSavedReports(definitionId || null);
  const selected =
    reports.find((report) => report.id === Number(settings.reportId)) ?? reports[0];
  const [result, setResult] = useState<EFormReportQueryResult | null>(null);
  useEffect(() => {
    if (!selected) {
      setResult(null);
      return;
    }
    let active = true;
    void queryEFormReport(definitionId, selected.queryJson as unknown as Record<string, unknown>)
      .then((value) => {
        if (active) setResult(value as EFormReportQueryResult);
      })
      .catch(() => {
        if (active) setResult(null);
      });
    return () => {
      active = false;
    };
  }, [definitionId, selected]);
  return (
    <div className="h-full overflow-auto">
      {editing ? (
        <Select
          className="mb-2"
          value={selected?.id ?? ''}
          placeholder="Select saved report"
          options={reports.map((report) => ({ value: report.id, label: report.name }))}
          onChange={(event) =>
            onSettingsChange?.({ ...settings, reportId: Number(event.target.value) })
          }
        />
      ) : null}
      <ReportPivotResult
        result={result}
        chartType={(selected?.queryJson.chartType || 'table') as EFormReportChartType}
        showTotals={Boolean(selected?.queryJson.showTotals)}
        showRowCount={false}
        emptyHint={selected ? 'This report returned no rows.' : 'No saved report selected.'}
      />
    </div>
  );
}
